import React from "react";
import ConvertDataService from "../../../../services/util/ConvertDatas";
import { Table } from "react-bootstrap";

const HistoryTableConvert = ({ data }) => {
    return (
        data.length ? 
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Última atualização</th>
                            <th>Departamento</th>
                            <th>Regime Contrato</th>
                            <th>Carga Horária</th>
                            <th>Função</th>
                            <th>Salário</th>
                            <th>Classificação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>{item.data_inicio && ConvertDataService.convertDataToDDmmYYYY(item.data_inicio)}</td>
                                <td>{item.departamento}</td>
                                <td>{item.regime_contrato}</td>
                                <td>{item.carga_horaria}h</td>
                                <td>{item.funcao}</td>
                                <td>R$ {item.salario.toLocaleString('pt-br')}</td>
                                <td>{item.classificacao}</td>
                            </tr>
                        ))
                        }
                    </tbody>
                </Table> : <>Não há dados de histórico para este colaborador.</>
    );
};  

const HistoryTableConvenia = ({ data }) => {
    function capitalizeFirstLetter(str) {
        if (!str) return "";
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    return (
        <div>
            {
                data.message ? <h5>{data.message}</h5> :
            
            <Table striped bordered hover>
                <thead>
                        <tr>
                            <th>Data e hora</th>
                            <th>Usuário</th>
                            <th>Informação alterada</th>
                            <th>Valor anterior</th>
                            <th>Valor novo</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>{ConvertDataService.convertDataToDDmmExtenseYYYY(item.data_atualizacao, true)}</td>
                                <td>{item.origem_atualizacao}</td>
                                <td>{item.informacao_atualizada}</td>
                                <td>{item.dados_antigos}</td>
                                <td>{item.dados_novos}</td>
                            </tr>
                        ))
                        }
                    </tbody>
            </Table>
            }
        </div>
    );
};

export { HistoryTableConvert, HistoryTableConvenia };

